import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { SdkClientUpdateInput } from '../generated/globalTypes';
import { updateSdkClientMutation, updateSdkClientMutationVariables } from '../generated/updateSdkClientMutation';
import { sdkClientFieldsFragment } from '../models/SdkClient';

/**
 * Get a callback to update a SdkClient in the store.
 */
export function useUpdateSdkClientCallback(): [(id: string, model: SdkClientUpdateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<updateSdkClientMutation, updateSdkClientMutationVariables>(
        gql`
            mutation updateSdkClientMutation ($model: SdkClientUpdateInput!) {
                updateSdkClient(model: $model) {
                    ...sdkClientFields
                }
            }

            ${sdkClientFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string, model: SdkClientUpdateInput) => {
        const result = await mutationAction({ variables: { model: { ...model, id: id } } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
